// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { precisionKm } from 'config/constants'
import { convertBetweenKMandMI } from 'helpers/unitConversion'

import {
  castToFloat,
  roundToFixed,
} from 'helpers/reduxFormFunctions'

const createKilometersAndMilesString = value => (
  castToFloat(value) !== null
    ? `${roundToFixed(value, precisionKm)}km / ${convertBetweenKMandMI(value, 'US')}mi`
    : 'N/A'
)

export default createKilometersAndMilesString
